<!--
Created by ZB 2022年5月30日
-->
<template>
	<div :class="['divider-box',{'url-jump':current.clickJumpUrl}]" @click="jumpUrl()">
		<!-- <div class="divider-tit">{{ current.temTitle }}</div> -->
		<!-- 样式1 -->
		<div
			class="divider-item item-solid"
			v-if="dividerStyle.name == 'solid'"
		>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>
			<div
				class="divider-line"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>
		<!-- 样式2 -->
		<div
			class="divider-item item-dotted"
			v-if="dividerStyle.name == 'dotted'"
		>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>
			<div
				class="divider-line"
				:style="{'borderColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>
		<!-- 样式3 -->
		<div
			class="divider-item item-left-thick"
			v-if="dividerStyle.name == 'leftThick'"
		>

			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

			<div class="divider-line">
				<div
					class="small-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
				<div
					class="big-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>
		<!-- 样式4 -->
		<div
			class="divider-item item-middle-thick"
			v-if="dividerStyle.name == 'middleThick'"
		>

			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

			<div class="divider-line">
				<div class="small-box">
					<div
						class="left-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="center-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="right-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="big-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>

		<!-- 样式5 -->
		<div
			class="divider-item item-mtwo-oclock"
			v-if="dividerStyle.name == 'mTwoOclock'"
		>

			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

			<div class="divider-line">
				<div class="small-box">
					<div
						class="left-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="right-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="big-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>

		<!-- 样式6 -->
		<div
			class="divider-item item-ltwo-oclock"
			v-if="dividerStyle.name == 'lTwoOclock'"
		>

			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

			<div class="divider-line">
				<div class="small-box">
					<div
						class="left-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="right-box"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="big-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>

		<!-- 样式7 -->
		<div
			class="divider-item item-middle-null"
			v-if="dividerStyle.name == 'middleNull'"
		>
			<div class="left-box">
				<div
					class="line"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
				<div class="block">
					<div
						class="block1"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="block2"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
			</div>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>
			<div class="right-box">
				<div class="block">
					<div
						class="block2"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="block1"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="line"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>

		<!-- 样式8 -->
		<div
			class="divider-item item-square"
			:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			v-if="dividerStyle.name == 'square'"
		>
			<div class="block"></div>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

		</div>

		<!-- 样式9 -->
		<div
			class="divider-item item-rounded"
			:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			v-if="dividerStyle.name == 'rounded'"
		>
			<div class="block"></div>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>

		</div>

		<!-- 样式10 -->
		<div
			class="divider-item item-left-rounded"
			:style="{'borderColor':current.lineMainColor || dividerStyle.lineColor}"
			v-if="dividerStyle.name == 'leftRounded'"
		>
			<div
				class="block"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			>
				<div
					class="divider-txt"
					:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
				>{{ current.temTitle }}</div>
			</div>
		</div>

		<!-- 样式11 -->
		<div
			class="divider-item item-left-edge"
			v-if="dividerStyle.name == 'leftEdge'"
		>
			<div class="block">
				<div
					class="divider-txt"
					:style="{'color':current.lineTitleColor || dividerStyle.textColor,'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				>{{ current.temTitle }}</div>
				<div
					class="shadow"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
				<div class="shadow-mb"></div>
			</div>
			<div
				class="line"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>

		<!-- 样式12 -->
		<div
			class="divider-item item-middle-edge"
			v-if="dividerStyle.name == 'middleEdge'"
		>
			<div class="block">
				<div class="edge left-edge">
					<div
						class="shadow"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div class="shadow-mb"></div>
					<div
						class="triangle"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="divider-txt"
					:style="{'color':current.lineTitleColor || dividerStyle.textColor,'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				>{{ current.temTitle }}</div>
				<div class="edge right-edge">
					<div
						class="triangle"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="shadow"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div class="shadow-mb"></div>
				</div>
			</div>
			<div
				class="line"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>

		<!-- 样式13 -->
		<div
			class="divider-item item-left-round"
			v-if="dividerStyle.name == 'leftRound'"
		>
			<div class="block">
				<div class="round-box">
					<div
						class="round1"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
					<div
						class="round2"
						:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
					></div>
				</div>
				<div
					class="divider-txt"
					:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
				>{{ current.temTitle }}</div>
			</div>
			<div
				class="line"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>

		<!-- 样式14 -->
		<div
			class="divider-item item-middle-round"
			:style="{'borderColor':current.lineMainColor || dividerStyle.lineColor}"
			v-if="dividerStyle.name == 'middleRound'"
		>
			<div class="small-box left">
				<div
					class="left-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
				<div
					class="right-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor}"
			>{{ current.temTitle }}</div>
			<div class="small-box right">
				<div
					class="right-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
				<div
					class="left-box"
					:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
				></div>
			</div>

		</div>

		<!-- 样式15 -->
		<div
			class="divider-item item-both-endsdot"
			v-if="dividerStyle.name == 'bothEndsDot'"
		>
			<div
				class="divider-txt"
				:style="{'color':current.lineTitleColor || dividerStyle.textColor,'borderColor':current.lineMainColor || dividerStyle.lineColor}"
			>{{ current.temTitle }}</div>
			<div
				class="small-box left"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
			<div
				class="small-box right"
				:style="{'backgroundColor':current.lineMainColor || dividerStyle.lineColor}"
			></div>
		</div>


	</div>
</template>

<script>
	import {
		FORM_STATUS__FILL,
		FORM_STATUS__EDIT
	} from "../types"

	export default {
		props: {
			value: Object,
			type: {
				type: Number,
				default: FORM_STATUS__FILL
			}
		},
		data() {
			return {
				current: this.value,
				dividerStyle: null,
			}
		},
		computed: {
			
		},
		watch:{
			'current.lineShowStyle':{
				handler(v){
					this.dividerStyle = this.current.styleList.find(item => {
						return item.name == this.current.lineShowStyle;
					})
				},
				deep:true
			},
		},
		created() {
			this.dividerStyle = this.current.styleList.find(item => {
				return item.name == this.current.lineShowStyle;
			})
		},
		methods: {
			jumpUrl() {
				if(this.current.clickJumpUrl){
					window.open(this.current.clickJumpUrl);
				}
			}
		},
	}
</script>

<style lang="less">
	.divider-box {
		padding: 10px 5px 10px 15px;
		margin-bottom: 0;

		.divider-item {
			.divider-txt {
				font-size: 14px;
				color: #333;
			}
		}

		// 样式1
		.item-solid {
			.divider-txt {
				margin-bottom: 5px;
			}

			.divider-line {
				height: 1px;
				width: 100%;
			}
		}

		// 2
		.item-dotted {
			.divider-txt {
				margin-bottom: 5px;
			}

			.divider-line {
				height: 0;
				width: 100%;
				border-bottom: 1px dotted #4260FA;
			}
		}

		// 3
		.item-left-thick {
			display: flex;
			align-items: center;

			.divider-txt {
				margin-right: 10px;
			}

			.divider-line {
				display: flex;
				flex: 1;
				align-items: center;

				.small-box {
					height: 3px;
					width: 5%;
					border-radius: 1.5px;
				}

				.big-box {
					height: 1px;
					width: 95%;
					opacity: .7;
				}
			}
		}

		// 4
		.item-middle-thick {
			.divider-txt {
				margin-bottom: 5px;
				text-align: center;
			}

			.divider-line {
				display: flex;
				flex-direction: column;
				align-items: center;

				.small-box {
					height: 5px;
					width: 20%;
					display: flex;

					.left-box {
						height: 5px;
						width: 5px;
						transform: skewX(-45deg);
					}

					.center-box {
						flex: 1;
						margin-left: -3px;
						margin-right: -3px;
					}

					.right-box {
						height: 5px;
						width: 5px;
						transform: skewX(45deg);
					}
				}

				.big-box {
					height: 1px;
					width: 100%;
				}
			}
		}

		// 5
		.item-mtwo-oclock {
			.divider-txt {
				margin-bottom: 5px;
				text-align: center;
			}

			.divider-line {
				display: flex;
				flex-direction: column;
				align-items: center;

				.small-box {
					width: 25%;
					display: flex;
					justify-content: space-between;
					margin-bottom: 1px;

					.left-box {
						height: 5px;
						width: 20px;
						border-radius: 0 3px 0 3px;
					}

					.right-box {
						height: 5px;
						width: 20px;
						border-radius: 3px 0 3px 0;
					}
				}

				.big-box {
					height: 1px;
					width: 100%;
				}
			}
		}

		// 6
		.item-ltwo-oclock {
			display: flex;
			align-items: center;

			.divider-txt {
				margin-right: 10px;
			}

			.divider-line {
				flex: 1;
				display: flex;
				flex-direction: column;
				position: relative;

				.small-box {
					position: absolute;
					top: -15px;
					transform: skewX(-25deg);
					left: 2.5px;

					.left-box {
						display: inline-block;
						height: 5px;
						width: 3px;
					}

					.right-box {
						display: inline-block;
						height: 10px;
						width: 3px;
					}
				}

				.big-box {
					width: 100%;
					height: 1px;
				}
			}
		}

		// 7
		.item-middle-null {
			display: flex;
			align-items: center;

			.left-box,
			.right-box {
				width: 50%;
				display: flex;
				align-items: center;

				.line {
					flex: 1;
					height: 1px;
				}

				.block {
					display: flex;
					align-items: center;
					width: 10px;
					justify-content: space-between;

					.block1 {
						height: 8px;
						width: 3px;
					}

					.block2 {
						height: 12px;
						width: 3px;
					}
				}
			}

			.left-box {
				.block {
					transform: skewX(25deg);
				}
			}

			.right-box {
				.block {
					transform: skewX(-25deg);
				}
			}

			.divider-txt {
				width: 25%;
				text-align: center;
			}
		}

		// 8
		.item-square {
			position: relative;
			height: 30px;
			line-height: 30px;
			padding-left: 15px;

			.block {
				width: 4px;
				height: 15px;
				background-color: #fff;
				float: left;
				margin-right: 10px;
			}
		}

		// 9
		.item-rounded {
			height: 30px;
			line-height: 30px;
			padding-left: 15px;
			border-radius: 15px;

			.block {
				width: 10px;
				height: 10px;
				background-color: rgba(255, 255, 255, .6);
				margin-right: 10px;
				border-radius: 5px;
				display: inline-block;
			}

			.divider-txt {
				display: inline-block;
			}
		}

		// 10
		.item-left-rounded {
			border-bottom: 1px solid #4260FA;
			padding-bottom: 1px;

			.block {
				height: 30px;
				line-height: 30px;
				border-radius: 15px 15px 15px 0;
				text-align: center;
				background-color: #4260FA;
				width: 140px;

				.divider-txt {
					color: #fff;
				}
			}
		}

		// 11
		.item-left-edge {
			display: flex;
			align-items: center;

			.block {
				position: relative;

				.divider-txt {
					position: relative;
					height: 30px;
					line-height: 30px;
					text-align: center;
					transform: skewX(-10deg);
					width: 140px;
					z-index: 2;
					color: #fff;
				}

				.shadow {
					position: absolute;
					width: 15px;
					height: 15px;
					right: -2.5px;
					transform: skewX(-30deg);
					bottom: 0;
					z-index: 0;
				}

				.shadow-mb {
					position: absolute;
					background-color: rgba(0, 0, 0, .3);
					width: 15px;
					height: 15px;
					right: -2.5px;
					transform: skewX(-30deg);
					bottom: 0;
					z-index: 1;
				}
			}

			.line {
				height: 1px;
				flex: 1;
			}
		}

		// 12
		.item-middle-edge {
			height: 28px;

			.block {
				margin: 0 auto;
				width: 100px;
				position: relative;

				.edge {
					.triangle {
						position: absolute;
						height: 28px;
						width: 20px;
						top: 0;
						z-index: 2;
					}

					.shadow {
						position: absolute;
						height: 10px;
						width: 10px;
						top: 0;
						z-index: 0;
					}

					.shadow-mb {
						position: absolute;
						height: 10px;
						width: 10px;
						background-color: rgba(0, 0, 0, .3);
						top: 0;
						z-index: 1;
					}
				}

				.left-edge {
					.triangle {
						left: -12px;
						transform: skewX(25deg);
					}

					.shadow {
						left: -22px;
						transform: skewX(-25deg);
					}

					.shadow-mb {
						left: -22px;
						transform: skewX(-25deg);
					}
				}

				.right-edge {
					.triangle {
						right: -12px;
						transform: skewX(-25deg);
					}

					.shadow {
						right: -22px;
						transform: skewX(25deg);
					}

					.shadow-mb {
						right: -22px;
						transform: skewX(25deg);
					}
				}

				.divider-txt {
					color: #fff;
					width: 100px;
					text-align: center;
					height: 28px;
					line-height: 28px;
				}
			}

			.line {
				margin-top: -18px;
				height: 1px;
				width: 100%;
			}
		}

		// 13
		.item-left-round {
			.block {
				display: flex;
				align-items: center;

				.round-box {
					display: flex;
					align-items: flex-end;

					.round1 {
						height: 12px;
						width: 12px;
						border-radius: 50%;
						background-color: #4260FA;
					}

					.round2 {
						margin-left: -3px;
						height: 26px;
						width: 26px;
						border-radius: 50%;
						opacity: .3;
					}
				}

				.divider-txt {
					margin-left: -5px;
				}
			}

			.line {
				height: 1px;
				flex: 1;
				opacity: .3;
				margin-left: 25.5px;
				margin-top: -1px;
			}
		}

		// 14
		.item-middle-round {
			display: flex;
			align-items: center;
			justify-content: center;
			border-bottom: 1px dashed #8E98F5;
			padding: 0 0 10px 0;

			.divider-txt {
				width: 100px;
				text-align: center;
			}

			.small-box {
				display: flex;
				align-items: center;

				>div {
					width: 6px;
					height: 6px;
					border-radius: 50%;
					margin: 0 5px;
				}

				.right-box {
					opacity: .5;
				}
			}
		}

		// 15
		.item-both-endsdot {
			position: relative;

			.divider-txt {
				text-align: center;
				border-bottom: 1px dashed #8E98F5;
				padding: 0 0 10px 0;
			}

			.small-box {
				width: 8px;
				height: 5px;
				position: absolute;
				top: 24px;

				&.left {
					left: 0;
				}

				&.right {
					right: 0;
				}
			}
		}


	}

	.url-jump{
		.divider-item{
			cursor: pointer;
		}
	}
</style>
